<template>
	<div>
		<date-range-picker
			:dateRange="timeValue"
			@update="changeValue"
			@close="changeValue"
			:locale-data="locale"
			opens="left"
			:ranges="noRanges ? false : ranges"
			@toggle="changeLanguage"
			:single-date-picker="single"
			:always-show-calendars="true"
			:minDate="minDateOrder ? minDateOrder : null"
			ref="openDate"
		>
			<div slot="input">
				<span v-if="!noRanges"
					>{{ formatStartDate() }} - {{ formatEndDate() }}</span
				>
				<span v-else>{{ formatStartDate() }}</span>
				<span class="mobile-icon" style="margin-left: 5px">
					<font-awesome-icon icon="calendar-alt" />
				</span>
			</div>
		</date-range-picker>
	</div>
</template>

<script>
import moment from "moment";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

export default {
	components: {
		DateRangePicker,
	},
	props: {
		msg: String,
		time: Array,
		single: Boolean,
		noRanges: Boolean,
		minDateOrder: Date,
	},
	data() {
		return {
			locale: {
				locale: moment.locale(localStorage.language),
				direction: "ltr", //direction of text
				format: "DD-MM-YYYY", //fomart of the dates displayed
				separator: " - ", //separator between the two ranges
				applyLabel: "Apply",
				cancelLabel: "Cancel",
				weekLabel: "W",
				customRangeLabel: "Custom Range",
				daysOfWeek: moment.weekdaysMin(), //array of days - see moment documenations for details
				monthNames: moment.monthsShort(), //array of month names - see moment documenations for details
				firstDay: 1, //ISO first day of week - see moment documenations for details,
			},
			timeValue: "",
		};
	},
	computed: {
		ranges: function() {
			if (localStorage.language === "el-GR") {
				return {
					"Αυτός ο μήνας": [moment().startOf("month"), moment()],
					"Προηγούμενος μήνας": [
						moment()
							.subtract(1, "month")
							.startOf("month"),
						moment()
							.subtract(1, "month")
							.endOf("month"),
					],
					"Τελευταίοι 3 μήνες": [
						moment()
							.subtract(3, "month")
							.startOf(moment()),
						moment(),
					],
					"Τρέχον έτος": [moment().startOf("year"), moment().endOf("year")],
				};
			} else {
				return {
					"This month": [moment().startOf("month"), moment()],
					"Last month": [
						moment()
							.subtract(1, "month")
							.startOf("month"),
						moment()
							.subtract(1, "month")
							.endOf("month"),
					],
					"Last 3 months": [
						moment()
							.subtract(3, "month")
							.startOf(moment()),
						moment(),
					],
					"Current year": [moment().startOf("year"), moment().endOf("year")],
				};
			}
		},
	},
	created() {
		this.timeValue = this.time;
	},
	watch: {
		time: function(val) {
			this.timeValue = val;
		},
	},
	methods: {
		changeValue(newValue) {
			this.timeValue = [newValue.startDate, newValue.endDate];
			this.$emit("close", this.timeValue);
		},
		changeLanguage() {
			this.locale.locale = moment.locale(localStorage.language);
			this.$emit("toggle", this.locale.locale);
		},
		formatStartDate() {
			return moment(this.timeValue[0]).format("DD-MM-YYYY");
		},
		formatEndDate() {
			return moment(this.timeValue[1]).format("DD-MM-YYYY");
		},
		toggle() {
			this.$refs.openDate.open = true;
		},
	},
};
</script>
